import React from "react";

import { Background } from "./styles";

function BackgroundLight() {
  return <Background />;
}

export default BackgroundLight;
